import "./expandable-item.css";

window.addEventListener("DOMContentLoaded", () => {
	const expandableItems = document.querySelectorAll(".des-expandable-item");

	expandableItems.forEach((expandableItem) => {
		if ("#" + expandableItem.id != window.location.hash.replace("bookmark-", "")) {
			expandableItem.classList.add("des-expandable-item--collapsed");
		} else {
			expandableItem.closest(".des-expandable-item").scrollIntoView({
				behavior: "smooth",
			});
		}
	});

	expandableItems.forEach((expandableItem) => {
		expandableItem.addEventListener("click", (event) => {
			if (
				event.target.matches(
					".des-expandable-item__title, .des-expandable-item__title *"
				)
			) {
				expandableItem.classList.toggle("des-expandable-item--collapsed");
				if ( !expandableItem.classList.contains("des-expandable-item--collapsed") )
				{
					event.target.closest(".des-expandable-item").scrollIntoView({
						behavior: "smooth",
					});
				}
				 window.location.href =
						"#bookmark-" + event.target.closest(".des-expandable-item").id;
				event.preventDefault();
			}
		});
	});



	if (window.location.hash != "") {
		let id = window.location.hash.replace(/^#bookmark-/, "");
		let bookmark = document.getElementById(id);

		if (bookmark) {
			window.location = "#" + id;
		}
	}
});
